import { motion } from 'framer-motion';
import { styled, css } from 'styled-components';
import { Media } from '../../../../../theme/Media';
import Icons from '../../../../Elements/Icons';
import { ITEMS_LIST_PADDING, DEFAULT_TRANSITION, SPACER_DEFAULT, SUBMENU_VIEWPORT_OFFSET } from '../../constants';
export const ItemIcon = styled.div `
  margin-right: calc(${SPACER_DEFAULT} / 2);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  position: relative;
`;
export const NotificationIndicatorWrapper = styled.div `
  position: absolute;
  top: 8px;
  right: 8px;
  pointer-events: none;
  display: inline-flex;
`;
export const ItemTitle = styled.span `
  ${({ theme }) => theme.typography.textMedium};
  color: ${({ theme }) => theme.colors.black_1};
  user-select: none;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 4px;
  overflow: hidden;
`;
export const ItemHeader = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 14px;
  border-radius: 8px;
  transition: background-color ${DEFAULT_TRANSITION};
  position: relative;

  @media ${Media.lgMin} {
    ${ItemTitle} {
      transition: opacity ${DEFAULT_TRANSITION};
      opacity: ${({ $collapsed }) => ($collapsed ? 0 : 1)};
    }
  }
`;
export const ItemElement = styled.div `
  position: relative;
  overflow: hidden;
  padding: 0 ${ITEMS_LIST_PADDING};

  ${({ theme, $standalone }) => !$standalone &&
    css `
      &:hover {
        ${ItemHeader} {
          background-color: ${theme.colors.grey05_1};
        }
      }
    `}

  ${({ $isCollapsed, $isOpened, theme, $standalone }) => !$standalone &&
    $isCollapsed &&
    $isOpened &&
    css `
      ${ItemHeader} {
        background-color: ${theme.colors.grey05_1};
      }
    `}
`;
export const Wrapper = styled.div `
  position: relative;
`;
export const ItemTitleText = styled.span `
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const IconAngle = styled(Icons.Chevron).attrs(({ theme }) => ({
    color: theme.colors.grey100_1,
    size: 16,
})) `
  transition: ${DEFAULT_TRANSITION};
`;
export const ItemHeaderWrapper = styled.div `
  display: flex;
  align-items: center;
  overflow: hidden;
`;
export const MotionDiv = styled(motion.div ?? 'div') `
  position: fixed;
  left: ${({ coords }) => coords?.$left ?? 0}px;
  top: ${({ coords }) => coords?.$top ?? 0}px;
  padding-left: 12px;
`;
export const MotionDivWrapper = styled.div `
  ${({ $standalone, $isCollapsedNav }) => !$standalone && $isCollapsedNav
    ? css `
          background: ${({ theme }) => theme.colors.grey00_1};
          border: 1px solid ${({ theme }) => theme.colors.grey10_1};
          ${({ theme }) => theme.shadows.large};
          border-radius: 8px;
          overflow: hidden;
        `
    : css `
          padding: 0 ${ITEMS_LIST_PADDING} ${ITEMS_LIST_PADDING};
        `}
`;
export const SubListTitle = styled.div `
  background-color: ${({ theme }) => theme.colors.grey01_1};
  ${({ theme }) => theme.typography.textSmall};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey10_1};
  color: ${({ theme }) => theme.colors.grey100_1};
  text-align: center;
  padding: 4px;
`;
export const SubList = styled.div `
  padding: ${ITEMS_LIST_PADDING};
  min-width: 250px;
  max-height: calc(100vh - ${SUBMENU_VIEWPORT_OFFSET});
  overflow-y: auto;
`;
export const Label = styled.span `
  padding: 0 6px;
  ${({ theme }) => theme.typography.textMedium};
  color: ${({ theme }) => theme.colors.main};
  text-transform: uppercase;
  background-color: ${({ theme }) => theme.colors.mainLight};
  border-radius: 6px;
`;
